export class FiltrosConciliacionMensual{
    rucProv : string = '';
    FechaInicial : string = '';
    FechaFinal : string = '';

 }